// extracted by mini-css-extract-plugin
export var align = "MegaMenu-module--align--2944d";
export var altaccent = "MegaMenu-module--altaccent--886e2";
export var arrow = "MegaMenu-module--arrow--d4559";
export var box = "MegaMenu-module--box--e530c";
export var column = "MegaMenu-module--column--0d4c2";
export var content = "MegaMenu-module--content--b4072";
export var currentCard = "MegaMenu-module--currentCard--c5ff8";
export var delay = "MegaMenu-module--delay--b4ee6";
export var description = "MegaMenu-module--description--debc7";
export var extend = "MegaMenu-module--extend--d3111";
export var grid = "MegaMenu-module--grid--f914e";
export var gutter = "MegaMenu-module--gutter--1e473";
export var heading = "MegaMenu-module--heading--2b6d6";
export var icon = "MegaMenu-module--icon--8fdfe";
export var item = "MegaMenu-module--item--e9db2";
export var layout = "MegaMenu-module--layout--d1b4c";
export var link = "MegaMenu-module--link--8a27e";
export var links = "MegaMenu-module--links--4d3de";
export var list = "MegaMenu-module--list--f6766";
export var menu = "MegaMenu-module--menu--5b566";
export var nav = "MegaMenu-module--nav--2b70f";
export var open = "MegaMenu-module--open--d1c2e";
export var overlay = "MegaMenu-module--overlay--68e73";
export var primary = "MegaMenu-module--primary--de683";
export var primaryActive = "MegaMenu-module--primary-active--16151";
export var row = "MegaMenu-module--row--70afa";
export var secondary = "MegaMenu-module--secondary--153e2";
export var small = "MegaMenu-module--small--66bb5";
export var tall = "MegaMenu-module--tall--75715";
export var tight = "MegaMenu-module--tight--e63fe";